<template>
  <tree-select
    ref="select"
    class="zm-select"
    v-if="tree"
    v-bind="$props"
  >
    <template #prefix>
      <slot name="prefix"></slot>
    </template>
  </tree-select>
  <filterable-select
    ref="select"
    class="zm-select"
    v-else-if="filterable"
    v-bind="[$props,$attrs]"
  >
    <template #prefix>
      <slot name="prefix"></slot>
    </template>
    <template #empty>
      <slot name="empty"></slot>
    </template>
    <template #default>
      <slot></slot>
    </template>
    <template #popper-append>
      <slot name="popper-append"></slot>
    </template>
  </filterable-select>
  <normal-select
    v-else
    ref="select"
    class="zm-select"
    v-bind="$props"
  >
    <template #prefix>
      <slot name="prefix"></slot>
    </template>
    <template #post>
      <slot name="post"></slot>
    </template>
    <template #empty>
      <slot name="empty"></slot>
    </template>
    <template #default>
      <slot></slot>
    </template>
    <template #popper-append>
      <slot name="popper-append"></slot>
    </template>
    <template v-if="$scopedSlots.default" #default="props">
      <slot :item="props.item">
      </slot>
    </template>
  </normal-select>
</template>

<script>
import Select from '@zoom/zoom-ui/src/components/select/select.vue';
import NormalSelect from './normal-select.vue';

export default {
  name: 'opc-select',
  components: { NormalSelect },
  props: {
    postLabel: {
      type: String,
      default: ''
    }
  },
  extends: Select,
};
</script>
